import * as types from './actionTypes';
import createInitialState from './initialState';

const initialState = createInitialState();

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.TOGGLE_SIDEBAR:
      return state.set('sidebarOpened', payload);
    case types.CHANGE_SYSTEM_STATUS:
      return state.set('systemStatus', payload);
    case types.BY_PASS_MAINTENANCE_MODE:
      return state.set('isByPassMaintenanceMode', payload);
    default:
      return state;
  }
};
